import { useQuery } from '@tanstack/react-query';
import { useAuthStore } from '../store/auth.store';
import { apiFetch } from '../lib/api';

interface QuotaResult {
  used: number;
  limit: number;
  exceeded: boolean;
}

interface PlanInfo {
  name: string;
}

export function useQuota() {
  const accessToken = useAuthStore((s) => s.accessToken);

  return useQuery({
    queryKey: ['quota'],
    queryFn: async () => {
      const res = await apiFetch('/api/chat/quota');
      if (!res.ok) throw new Error('Failed to fetch quota');
      return (await res.json()) as {
        quota: QuotaResult | null;
        plan: PlanInfo | null;
      };
    },
    enabled: !!accessToken,
    refetchInterval: 60_000,
    staleTime: 30_000,
  });
}
